
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import { useEffect } from 'react';
const PaymentMethod = ({onChange, setStripe, setElements}) => {
  const stripe = useStripe();
  const elements = useElements();
  useEffect(()=>{
      setStripe(stripe)
      setElements(elements)
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe, elements])
  return (
      <PaymentElement onChange={(e)=>onChange(e)} />
  );
};

export default PaymentMethod;